/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, createRef } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import { flow, curry, shuffle } from 'lodash/fp';
import memoize from 'memoize-one';
import {
  Section,
  SectionHeader,
  Link,
  Button,
  Icon,
  Paragraph,
  BoxCaseStudy,
  BoxLayoutSymetrical,
  LoadMorePagination,
} from 'components';
import { ArticleBox, ReviewBox } from '..';
import { ICON_TYPES, BOX_TYPES } from 'config';
import { industry, service, data } from './logic';
import './CaseStudies.scss';

class CaseStudies extends Component {
  static FIXED_ORDER_COUNT = 6;

  sortCaseStudies = memoize(_data =>
    _data.sort((a, b) => {
      if (a.type === BOX_TYPES.CASE_STUDY && b.type === BOX_TYPES.CASE_STUDY) {
        if (!a.content.description.length && !b.content.description.length) {
          return 0;
        }

        if (!b.content.description.length) {
          return 1;
        }

        return -1;
      }

      if (b.type === BOX_TYPES.CASE_STUDY) {
        return 1;
      }

      if (a.type === BOX_TYPES.BLOG && b.type === BOX_TYPES.BLOG) {
        return a.id > b.id;
      }
      return -1;
    }),
  );

  filterCaseStudies = memoize(
    curry((industryFilter, serviceFilter, _data) =>
      _data.filter(item => {
        if (industryFilter !== null) {
          return item.content.industry.includes(industryFilter);
        }

        if (serviceFilter !== null) {
          return item.content.service.includes(serviceFilter);
        }

        return item;
      }),
    ),
  );

  limitCaseStudies = memoize(_data => {
    let blogCount = 0;

    return _data.filter(item => {
      if (item.type === 'BLOG') {
        blogCount += 1;

        return blogCount < 4;
      }

      return item;
    });
  });

  constructor(props) {
    super(props);

    this.refIndustryFilter = createRef();
    this.refServiceFilter = createRef();

    this.data = this.getOrderedData(data);

    this.state = {
      industryFilter: null,
      serviceFilter: null,
      isIndustryActive: false,
      isServiceActive: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  getOrderedData = _data => {
    const orderedCount = CaseStudies.FIXED_ORDER_COUNT;

    const ordered = _data.slice(0, orderedCount);
    const unordered = shuffle(_data.slice(orderedCount, _data.length));

    return ordered.concat(unordered);
  };

  getCalculatedCaseStudies = () => {
    const { industryFilter, serviceFilter } = this.state;

    const calculateData = flow(
      this.filterCaseStudies(industryFilter, serviceFilter),
      // this.sortCaseStudies,
      this.limitCaseStudies,
    );

    return calculateData(this.data);
  };

  handleClick = e => {
    if (this.refIndustryFilter.current && this.refServiceFilter.current) {
      if (
        this.refIndustryFilter.current.contains(e.target) ||
        this.refServiceFilter.current.contains(e.target)
      ) {
        return;
      }
      this.setState({ isIndustryActive: false, isServiceActive: false });
    }
  };

  toggleIndustryFilterView = () =>
    this.setState(prevState => ({
      isIndustryActive: !prevState.isIndustryActive,
      isServiceActive: false,
    }));

  toggleServiceFilterView = () =>
    this.setState(prevState => ({
      isServiceActive: !prevState.isServiceActive,
      isIndustryActive: false,
    }));

  updateFilters(label, filter) {
    const keysByLabel = {
      Industry: 'industryFilter',
      Service: 'serviceFilter',
    };

    this.setState({
      industryFilter: null,
      serviceFilter: null,
      [keysByLabel[label]]: filter,
    });
  }

  checkResults(label, newFilter, navigatePage) {
    navigatePage(1);

    this.updateFilters(label, newFilter);
  }

  renderFilters(label, items, navigatePage) {
    const { industryFilter, serviceFilter } = this.state;

    const filters = items.map(filter => (
      <li
        id={`filter-${filter}`}
        className={`case-studies__filter-button ${industryFilter === filter ||
          (serviceFilter === filter &&
            'case-studies__filter-button--active')}`}
        onClick={() => {
          this.checkResults(label, filter, navigatePage);
        }}
      >
        {filter}
      </li>
    ));

    return (
      <ul className={'case-studies__filters-list'}>
        <li
          className={'case-studies__filter-button'}
          onClick={() => {
            this.checkResults(label, null, navigatePage);
          }}
        >
          All
        </li>
        {filters}
      </ul>
    );
  }

  renderCaseStudies = (filtered, filteredCount, loadedData) => (
    <>
      <div className={'case-studies__result'}>
        We found {filteredCount} {filteredCount === 1 ? 'result' : 'results'}.
      </div>
      <BoxLayoutSymetrical>
        {filtered.length > 0 && this.renderTiles(filtered, loadedData)}
      </BoxLayoutSymetrical>
    </>
  );

  renderTiles = (posts, loadedData) => {
    const { allArticles, contributors } = this.props;

    return posts.map(post => {
      const articleData = allArticles.find(
        edge => edge.node.frontmatter.title === post.title,
      );

      return post.type === BOX_TYPES.BLOG ? (
        <ArticleBox
          key={`blog-post-${post.id}`}
          post={articleData}
          contributors={contributors}
          color={post.settings.tileColor}
          id={post.id}
        />
      ) : post.type === BOX_TYPES.REVIEW ? (
        <ReviewBox
          data={post}
        />
      ) : (
        <BoxCaseStudy
          data={{
            ...post,
            content: {
              ...post.content,
              coverImage: loadedData[post.content.coverImage]
                ? loadedData[post.content.coverImage].childImageSharp.fluid
                : post.content.coverImage,
              clientLogo: loadedData[post.content.clientLogo]
                ? loadedData[post.content.clientLogo].childImageSharp.fluid
                : post.content.clientLogo,
            },
          }}
          id={post.id}
        />
      );
    });
  };

  render() {
    const {
      industryFilter,
      serviceFilter,
      isIndustryActive,
      isServiceActive,
    } = this.state;

    return (
      <StaticQuery
        query={graphql`
          fragment WorkCaseStudyLogo on File {
            childImageSharp {
              fluid(maxWidth: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }

          fragment WorkCaseStudyCover on File {
            childImageSharp {
              fluid(maxWidth: 500) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }

          query {
            logoEres: file(relativePath: { eq: "logos/eres.png" }) {
              ...WorkCaseStudyLogo
            }
            logoVirgin: file(relativePath: { eq: "logos/virgin-color.png" }) {
              ...WorkCaseStudyLogo
            }
            logoSonnen: file(relativePath: { eq: "logos/sonnen-white.png" }) {
              ...WorkCaseStudyLogo
            }
            logoPolco: file(relativePath: { eq: "logos/polco-white.png" }) {
              ...WorkCaseStudyLogo
            }
            logoIono: file(relativePath: { eq: "logos/iono-white.png" }) {
              ...WorkCaseStudyLogo
            }
            logo910: file(relativePath: { eq: "logos/tojar_logo.png" }) {
              ...WorkCaseStudyLogo
            }
            logoHTW: file(relativePath: { eq: "logos/hack_the_wind.png" }) {
              ...WorkCaseStudyLogo
            }
            logoPSO: file(relativePath: { eq: "logos/pso_logo.png" }) {
              ...WorkCaseStudyLogo
            }
            logoPractiTest: file(
              relativePath: { eq: "logos/practi-test.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoViners: file(relativePath: { eq: "logos/viners.png" }) {
              ...WorkCaseStudyLogo
            }
            logoBrassWillow: file(
              relativePath: { eq: "logos/brass-willow.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoInCampagna: file(
              relativePath: { eq: "logos/in-campagna.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoHolaSpirit: file(
              relativePath: { eq: "logos/holaspirit.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoApasmart: file(relativePath: { eq: "logos/apasmart.png" }) {
              ...WorkCaseStudyLogo
            }
            logoTakamol: file(relativePath: { eq: "logos/takamol.png" }) {
              ...WorkCaseStudyLogo
            }
            logoPlanetEscape: file(
              relativePath: { eq: "logos/planet-escape.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoShowbiz: file(
              relativePath: { eq: "logos/showbiz-models.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoColeMason: file(relativePath: { eq: "logos/cole-mason.png" }) {
              ...WorkCaseStudyLogo
            }
            logoPakt: file(relativePath: { eq: "logos/pakt.png" }) {
              ...WorkCaseStudyLogo
            }
            logoOneida: file(relativePath: { eq: "logos/oneida.png" }) {
              ...WorkCaseStudyLogo
            }
            logoSpaMonkeys: file(
              relativePath: { eq: "logos/spa-monkeys.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoHeartpace: file(relativePath: { eq: "logos/heartpace.png" }) {
              ...WorkCaseStudyLogo
            }
            logoNumeraLighting: file(
              relativePath: { eq: "logos/numera-lighting.png" }
            ) {
              ...WorkCaseStudyLogo
            }
            logoRehalati: file(relativePath: { eq: "logos/rehalati.png" }) {
              ...WorkCaseStudyLogo
            }
            logoLrBeauty: file(relativePath: { eq: "logos/lr-beauty.png" }) {
              ...WorkCaseStudyLogo
            }
            logoEzycount: file(relativePath: { eq: "logos/ezycount.png" }) {
              ...WorkCaseStudyLogo
            }
            logoDigpro: file(relativePath: { eq: "logos/digpro.png" }) {
              ...WorkCaseStudyLogo
            }
            virginImage: file(
              relativePath: { eq: "work/virgin-radio-oman-screen.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            blablaImage: file(
              relativePath: { eq: "work/blablacar-app-mockup.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            eresImage: file(
              relativePath: { eq: "work/eres-yachting-mockups.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            sonnenImage: file(relativePath: { eq: "work/work-sonnen.jpg" }) {
              ...WorkCaseStudyCover
            }
            sonnenChargerImage: file(
              relativePath: { eq: "work/work-sonnen-charger.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            ionoImage: file(relativePath: { eq: "work/ionoTile.jpg" }) {
              ...WorkCaseStudyCover
            }
            polcoImage: file(relativePath: { eq: "work/work-polco.jpg" }) {
              ...WorkCaseStudyCover
            }
            bldrImage: file(relativePath: { eq: "work/boldare.jpg" }) {
              ...WorkCaseStudyCover
            }
            tojarImage: file(relativePath: { eq: "work/tojar.jpg" }) {
              ...WorkCaseStudyCover
            }
            htwImage: file(
              relativePath: { eq: "work/predictive-maintenance.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            psoImage: file(relativePath: { eq: "work/PSO.jpg" }) {
              ...WorkCaseStudyCover
            }
            practiTestImage: file(
              relativePath: { eq: "work/work-practitest.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            vinersImage: file(relativePath: { eq: "work/work-viners.jpg" }) {
              ...WorkCaseStudyCover
            }
            brassWillowImage: file(
              relativePath: { eq: "work/work-brass-willow.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            inCampagnaImage: file(
              relativePath: { eq: "work/work-incampagna.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            holaSpiritImage: file(
              relativePath: { eq: "work/work-holaspirit.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            apasmartImage: file(
              relativePath: { eq: "work/work-apasmart.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            a2lImage: file(relativePath: { eq: "work/work-a2l.jpg" }) {
              ...WorkCaseStudyCover
            }
            planetEscapeImage: file(
              relativePath: { eq: "work/work-planet-escape.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            showbizImage: file(relativePath: { eq: "work/work-showbiz.jpg" }) {
              ...WorkCaseStudyCover
            }
            coleMasonImage: file(
              relativePath: { eq: "work/work-cole-mason.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            paktImage: file(relativePath: { eq: "work/work-pakt.jpg" }) {
              ...WorkCaseStudyCover
            }
            oneidaImage: file(relativePath: { eq: "work/work-oneida.jpg" }) {
              ...WorkCaseStudyCover
            }
            spaMonkeysImage: file(
              relativePath: { eq: "work/work-spa-monkeys.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            heartpaceImage: file(
              relativePath: { eq: "work/work-heartpace.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            numeraLightingImage: file(
              relativePath: { eq: "work/work-numera-lighting.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            rehalatiImage: file(
              relativePath: { eq: "work/work-rehalati.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            lrBeautyImage: file(
              relativePath: { eq: "work/work-lr-beauty.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            ezycountImage: file(
              relativePath: { eq: "work/work-ezycount.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            chilidTealspaceImage: file(
              relativePath: { eq: "work/chilid-tealspace.jpg" }
            ) {
              ...WorkCaseStudyCover
            }
            digproImage: file(relativePath: { eq: "work/work-digpro.jpg" }) {
              ...WorkCaseStudyCover
            }
          }
        `}
        render={loadedData => (
          <LoadMorePagination
            index="case-studies"
            loadCount={6}
            data={this.getCalculatedCaseStudies()}
          >
            {({ items, totalCount, loadMore, navigatePage }) => (
              <>
                <Section
                  id={'case-studies'}
                  additionalClass={'case-studies'}
                  spaceless
                >
                  <SectionHeader
                    size={'small'}
                    lineColor={'white'}
                    color={'white'}
                    headingType={2}
                  >
                    Explore our
                    <br />
                    case studies
                  </SectionHeader>
                  <div className={'case-studies__filters'}>
                    <Paragraph
                      color={'white'}
                      additionalClass={
                        'case-studies__filter-by case-studies--desktop'
                      }
                    >
                      Filter by:
                    </Paragraph>
                    <div
                      className={`case-studies__filter ${isIndustryActive &&
                        'opened'}`}
                      onClick={this.toggleIndustryFilterView}
                      ref={this.refIndustryFilter}
                    >
                      <Paragraph>{industryFilter || 'Industry'}</Paragraph>
                      <Icon
                        icon={ICON_TYPES.RIGHT_ARROW}
                        size={'default'}
                        color={'black'}
                      />
                      {this.renderFilters('Industry', industry, navigatePage)}
                    </div>
                    <Paragraph color={'white'}>or by</Paragraph>
                    <div
                      className={`case-studies__filter ${isServiceActive &&
                        'opened'}`}
                      onClick={this.toggleServiceFilterView}
                      ref={this.refServiceFilter}
                    >
                      <Paragraph>{serviceFilter || 'Service'}</Paragraph>
                      <Icon
                        icon={ICON_TYPES.RIGHT_ARROW}
                        size={'default'}
                        color={'black'}
                      />
                      {this.renderFilters('Service', service, navigatePage)}
                    </div>
                  </div>
                </Section>

                <LazyLoad once offset={200}>
                  <Section
                    id={'case-studies__content'}
                    additionalClass={'case-studies__content'}
                    spaceless
                  >
                    <div className={'case-studies__container'}>
                      {this.renderCaseStudies(items, totalCount, loadedData)}
                    </div>
                    <div className={'case-studies__button-wrapper'}>
                      {loadMore && (
                        <div className={'case-studies__button'}>
                          <Button
                            tag={Link}
                            to={loadMore.path}
                            transparent
                            color={'black'}
                            onClick={loadMore.action}
                          >
                            Load more
                          </Button>
                        </div>
                      )}
                    </div>
                  </Section>
                </LazyLoad>
              </>
            )}
          </LoadMorePagination>
        )}
      />
    );
  }
}

export default CaseStudies;
